// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_cUsqO {
  padding: 24px 48px;
  background-color: var(--white-background);
  display: flex;
  justify-content: center;
}
.contentContainer_EJ9LV {
  background: var(--white-background);
}

.headerTitle_y4nTD {
  font-size: 22px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 8px;
}





.tableHeader_PpvBg {
  display: flex;
  padding: 12px 16px;
  color: #b5b7c0;
  font-weight: 500;
  font-size: 14px;
  border-bottom: 1px solid #eeeeee;
}


.eye_3RtjA {
  width: 20px;
  height: 20px;
  cursor: pointer;
}





.tableHeader_PpvBg span{
  display: flex;
  height: 49px;
  align-items: center;
}

.filterSort_pjM5A {
  font-weight: 300;
  color: var(--black-color);
  padding: 0px 16px;
  flex: 0.1 1;
  height: 30px;
  min-height: 30px;
  max-height: 30px;
  border-radius: 4px;
  border: 1px solid #bdbdbd;
  display: flex;
  align-items: center;
  font-size: 11px;
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
  min-width: 90px;
}

.filterSort_pjM5A b {
  font-weight: 400;
  font-size: 15px;
  margin-right: 6px;
}

.chevronIcon_NPULm {
  margin-left: auto;
  color: #09121f;
}

.dropdownOptions_AASoe {
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  width: 100%;
  background: var(--white-background);
  border: 1px solid #bdbdbd;
  margin-top: 4px;
  border-radius: 4px;
  box-shadow: 0px 4px 8px var(--_0000001a-shadow);
  z-index: 1000;
  overflow: hidden;
}

.dropdownOption_sBzsv {
  margin: 0px 12px;
  padding: 14px 0px;
  font-size: 12px;
  border-bottom: 1px solid #bdbdbd;
  font-weight: 500;
  color: #131313;
  cursor: pointer;
  transition: background-color 0.2s;
}


.eyeButton_jUyzp{
  background-color: transparent;
  border: none;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/UsersDashboard.module.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;;;;;AAMA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;;;;;AAMA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,WAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;;AAGA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap\");\n\n.container {\n  padding: 24px 48px;\n  background-color: var(--white-background);\n  display: flex;\n  justify-content: center;\n}\n.contentContainer {\n  background: var(--white-background);\n}\n\n.headerTitle {\n  font-size: 22px;\n  font-weight: 600;\n  color: #000000;\n  margin-bottom: 8px;\n}\n\n\n\n\n\n.tableHeader {\n  display: flex;\n  padding: 12px 16px;\n  color: #b5b7c0;\n  font-weight: 500;\n  font-size: 14px;\n  border-bottom: 1px solid #eeeeee;\n}\n\n\n.eye {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n\n\n\n\n.tableHeader span{\n  display: flex;\n  height: 49px;\n  align-items: center;\n}\n\n.filterSort {\n  font-weight: 300;\n  color: var(--black-color);\n  padding: 0px 16px;\n  flex: 0.1;\n  height: 30px;\n  min-height: 30px;\n  max-height: 30px;\n  border-radius: 4px;\n  border: 1px solid #bdbdbd;\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  justify-content: flex-start;\n  cursor: pointer;\n  position: relative;\n  min-width: 90px;\n}\n\n.filterSort b {\n  font-weight: 400;\n  font-size: 15px;\n  margin-right: 6px;\n}\n\n.chevronIcon {\n  margin-left: auto;\n  color: #09121f;\n}\n\n.dropdownOptions {\n  position: absolute;\n  top: calc(100% - 2px);\n  left: 0;\n  width: 100%;\n  background: var(--white-background);\n  border: 1px solid #bdbdbd;\n  margin-top: 4px;\n  border-radius: 4px;\n  box-shadow: 0px 4px 8px var(--_0000001a-shadow);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.dropdownOption {\n  margin: 0px 12px;\n  padding: 14px 0px;\n  font-size: 12px;\n  border-bottom: 1px solid #bdbdbd;\n  font-weight: 500;\n  color: #131313;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n\n.eyeButton{\n  background-color: transparent;\n  border: none;\n  outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_cUsqO`,
	"contentContainer": `contentContainer_EJ9LV`,
	"headerTitle": `headerTitle_y4nTD`,
	"tableHeader": `tableHeader_PpvBg`,
	"eye": `eye_3RtjA`,
	"filterSort": `filterSort_pjM5A`,
	"chevronIcon": `chevronIcon_NPULm`,
	"dropdownOptions": `dropdownOptions_AASoe`,
	"dropdownOption": `dropdownOption_sBzsv`,
	"eyeButton": `eyeButton_jUyzp`
};
export default ___CSS_LOADER_EXPORT___;
